import { render, staticRenderFns } from "./ReadPage.vue?vue&type=template&id=59f0de01"
import script from "./ReadPage.vue?vue&type=script&lang=js"
export * from "./ReadPage.vue?vue&type=script&lang=js"
import style0 from "./ReadPage.vue?vue&type=style&index=0&id=59f0de01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports